<template functional>
  <div
    class="filter-button-group"
    v-bind:class="[data.class, data.staticClass]"
  >
    <span v-if="props.label" class="label">{{ props.label }}</span>
    <b-button-group class="filter-group">
      <b-button
        size="sm"
        class="filter-button"
        v-for="button in props.buttons"
        v-bind:key="button.value"
        v-bind:variant="props.value === button.value ? 'success' : 'light'"
        v-bind:pressed="props.value === button.value"
        v-bind:class="{ bordered: props.bordered }"
        v-on:click="listeners.input(button.value)"
      >
        {{ button.text }}
      </b-button>
    </b-button-group>
  </div>
</template>

<script>
export default {
  name: 'AppFilterButtonGroup',
  props: {
    /**
     * ボタン定義
     */
    buttons: {
      type: Array,
      default: () => [],
    },
    /**
     * 選択値
     * @model
     */
    value: {
      type: [String, Number, Boolean],
      default: null,
    },
    /**
     * ラベル
     */
    label: {
      type: String,
      default: '',
    },
    /**
     * サイズ(Bootstrap)
     */
    size: {
      type: String,
      default: 'sm',
    },
    /**
     * borderをつける場合はtrue
     */
    bordered: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-button-group {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: $font-size-small;

  .label {
    color: $text-color;
    font-weight: $font-weight-bold;
    margin-right: 8px;
    line-height: 1.5;
  }

  .filter-button {
    font-size: $font-size-small;
    min-width: 3.5rem;
    min-height: 32px;

    &.bordered {
      border: 1px solid #ced4da;
    }

    &.btn-light {
      background-color: #f4f5f6;

      &:hover {
        background-color: #e0e1e2;
      }
    }

    &.btn-success {
      background-color: $entity-color-green !important;
      border-color: $entity-color-green !important;
    }
  }
}
</style>
